import axios from "axios";
import authHeader from "../auth-header";

const API_URL = process.env.REACT_APP_API_URL;

const getAll = async (params) => {
  return await axios.post(`${API_URL}/purchase-suspended/list`, params, { headers: authHeader() });
};

const getById = async (id) => {
  return await axios.get(`${API_URL}/purchase-suspended/${id}`, { headers: authHeader() });
};

const update = async (id,data) => {
  return await axios.put(`${API_URL}/purchase-suspended/${id}`,data,{
    headers: authHeader(),
  })
}

export default {
  getAll,
  getById,
  update
};
